export default __webpack_public_path__ + "static/media/icon_left.e3215993.svg";